import { useState } from 'react'
import {
  groupTagClasses,
  PERMISSION_DESCRIPTIONS,
  PERMISSION_DETAILS,
  PERMISSION_ICONS,
  PERMISSION_NAMES,
  PERMISSION_TECHNICAL_NAMES,
  permissionPillClasses,
} from '../constants'
import type { CapabilityGroupKey } from '../constants'

function Icon({ name }: { name: string | undefined }) {
  const cls = 'w-5 h-5'
  switch (name) {
    case 'book':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    case 'signature':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l9.932-9.931z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.5 7.125L16.862 4.487" />
        </svg>
      )
    case 'rocket':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    case 'coins':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-3.314 0-6 1.343-6 3s2.686 3 6 3 6-1.343 6-3-2.686-3-6-3z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 11v6c0 1.657 2.686 3 6 3s6-1.343 6-3v-6" />
        </svg>
      )
    case 'arrows':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16l-4-4m0 0l4-4m-4 4h18" />
        </svg>
      )
    case 'pencil':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      )
    case 'crane':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 21h18M6 21V7a2 2 0 012-2h8a2 2 0 012 2v14M10 9h4" />
        </svg>
      )
    case 'users':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-4-4h-1" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20H4v-2a4 4 0 014-4h1" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
        </svg>
      )
    case 'sliders':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 6v0m8 6v0m-6 6v0" />
        </svg>
      )
    case 'spark':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3l2 7h7l-6 4 2 7-5-5-5 2 2-6-2-6 5 2z" />
        </svg>
      )
    case 'crown':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8l2 10h10l2-10-4 3-3-5-3 5-4-3z" />
        </svg>
      )
    case 'shield':
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l7 4v6c0 5-3 9-7 10-4-1-7-5-7-10V6l7-4z" />
        </svg>
      )
    default:
      return (
        <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
  }
}

export function PermissionCard({
  permissionKey,
  capabilityGroupKey = 'identitySigning',
  checked,
  onToggle,
  interactive = true,
}: {
  permissionKey: string
  capabilityGroupKey?: CapabilityGroupKey
  checked: boolean
  onToggle: (permissionKey: string) => void
  interactive?: boolean
  allowedCallsCount?: number
  allowedDataKeysCount?: number
}) {
  const [detailsOpen, setDetailsOpen] = useState(false)
  const title = PERMISSION_NAMES[permissionKey] ?? permissionKey
  const description = PERMISSION_DESCRIPTIONS[permissionKey] ?? 'Enables controller to use your profile in this way.'
  const technical = PERMISSION_TECHNICAL_NAMES[permissionKey] ?? permissionKey
  const detailText = PERMISSION_DETAILS[permissionKey]?.detail
  const iconName = PERMISSION_ICONS[permissionKey]

  const selectedClasses = checked
    ? 'border-gray-300 dark:border-neutral-700 bg-white/80 dark:bg-neutral-800/60 shadow-[0_1px_0_rgba(0,0,0,0.04),0_16px_40px_rgba(0,0,0,0.10)]'
    : 'border-gray-200 dark:border-neutral-700 bg-white/65 dark:bg-neutral-800/40 hover:bg-white/80 dark:hover:bg-neutral-800/60'

  const tagClasses = permissionPillClasses(groupTagClasses(capabilityGroupKey))

  const content = (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
      <div className="min-w-0 flex-1 w-full flex flex-col gap-3">
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-lukso-pink/10 via-lukso-purple/10 to-lukso-purple/10 border border-gray-200/70 dark:border-neutral-600 text-gray-700 dark:text-gray-200 flex-shrink-0 self-start">
          <Icon name={iconName} />
        </span>
        <div className="min-w-0">
          <div className="font-semibold leading-tight text-gray-900 dark:text-white">{title}</div>
          <div className="mt-0.5 text-xs text-gray-600 dark:text-gray-300 leading-snug">
            {description}
            {detailText && (
              <>
                {' '}
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); setDetailsOpen((o) => !o) }}
                  className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 underline cursor-pointer"
                >
                  More detail
                </button>
              </>
            )}
          </div>
          <div className="mt-2 flex flex-wrap gap-2">
            <span className={tagClasses}>
              {technical}
            </span>
          </div>
        </div>

        {detailText && detailsOpen && (
          <div className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">
            {detailText}
          </div>
        )}
      </div>

      {interactive ? (
        <div className="flex justify-end sm:justify-end sm:flex-shrink-0 sm:pt-0.5">
          <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={`${checked ? 'Disable' : 'Enable'} ${title}`}
            onClick={(e) => {
              e.preventDefault()
              onToggle(permissionKey)
            }}
            className={`relative flex-shrink-0 w-11 h-6 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-cta-primary focus:ring-offset-2 dark:focus:ring-offset-surface ${
              checked
                ? 'bg-cta-primary'
                : 'bg-gray-300 dark:bg-neutral-600'
            }`}
          >
            <span
              className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow transition-transform ${
                checked ? 'translate-x-5' : 'translate-x-0'
              }`}
            />
          </button>
        </div>
      ) : (
        <div className="hidden sm:block w-11 flex-shrink-0" aria-hidden="true" />
      )}
    </div>
  )

  return (
    <div className={`rounded-xl border backdrop-blur transition-colors px-4 py-4 sm:px-5 ${selectedClasses}`}>
      {content}
    </div>
  )
}

